module.exports = __webpack_public_path__ + "img/hdfcschool-img.4d8586df.png";